// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ToolConfig } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteToolConfig(): (
  aufgabeId: string,
  toolId: string,
  key: string
) => Promise<ToolConfig> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, toolId, key) =>
      (await getAPI()).tools.deleteToolConfig({ aufgabeId, toolId, key }),
    [getAPI]
  );
}
